import "../Stylesheet/FooterCredit.css";
import { useLanguage } from "../Context/Languagecontext";

export default function FooterCredit() {
    const { language } = useLanguage();

    const content = {
        EN: <>Developed by <span>Mpeoples</span></>,
        TA: <>இந்த இணையதளம் <span>Mpeoples </span> நிறுவனத்தால் உருவாக்கப்பட்டது.</>,
        ML: <>ഈ വെബ്സൈറ്റ് <span>Mpeoples</span> നിർമ്മിച്ചതാണ്.</>
    };

    return (
        <div className="footer-credit">

            {/* Decorative Divider */}
            <div className="credit-divider">
                <span></span>
                <div className="dot"></div>
                <span></span>
            </div>

            {/* Content */}
            <div className="footer-credit-container">
                <img src="/assets/mp.jpg" alt="Mpeoples Logo" />
                <a
                    href="https://mpeoples.in/"
                    target="_blank"
                    rel="noopener noreferrer"

                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer"
                    }}
                >
                    <p style={{ cursor: "pointer" }}>
                        {content[language] || content.EN}
                    </p>
                </a>
            </div>

        </div>
    );
}